export default __webpack_public_path__ + "static/media/redCapeTransparentRed.6de5152d.png";